import React from 'react';
import { prepareNewsContentHtml } from '../utils/newsContent';

type Props = {
    content: string;
    className?: string;
};

const NewsContent: React.FC<Props> = ({ content, className = 'news-content' }) => {
    const html = prepareNewsContentHtml(content);
    if (!html) return null;

    return (
        <div
            className={className}
            dangerouslySetInnerHTML={{ __html: html }}
        />
    );
};

export default NewsContent;
